import React from "react";
import ModalSemPermissao from "./ModalSemPermissao";

export default function ComProtecao({ rota, tipo = "pode_ler", children }) {
  const usuario = JSON.parse(localStorage.getItem("usuario"));

  console.log("🔐 ComProtecao ativo");
console.log("🔐 Rota:", rota);
console.log("🔐 Tipo exigido:", tipo);
console.log("🔐 Usuário:", usuario);
console.log("🔐 Permissões:", usuario?.permissoes);


  const temPermissao = usuario?.permissoes?.some(
    (p) => p.rota === rota && p[tipo]
  );

  return temPermissao ? children : <ModalSemPermissao />;
}
